import { gql } from '@apollo/client';

const FETCH_ASSET_TYPES = gql`
  query {
    __type(name: "AssetTypeEnums") {
      enumValues {
        name
      }
    }
  }
`;

export { FETCH_ASSET_TYPES };
